"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchMessagesDone = exports.INBOX_FETCH_MESSAGES_DONE = exports.fetchMessagesError = exports.INBOX_FETCH_MESSAGES_ERROR = exports.fetchMessagesPending = exports.INBOX_FETCH_MESSAGES_PENDING = exports.INBOX_FETCH_MESSAGES = void 0;
var INBOX_FETCH_MESSAGES = "inbox/FETCH_MESSAGES";
exports.INBOX_FETCH_MESSAGES = INBOX_FETCH_MESSAGES;
var INBOX_FETCH_MESSAGES_PENDING = "inbox/FETCH_MESSAGES/PENDING";
exports.INBOX_FETCH_MESSAGES_PENDING = INBOX_FETCH_MESSAGES_PENDING;

var fetchMessagesPending = function fetchMessagesPending() {
  return {
    type: INBOX_FETCH_MESSAGES_PENDING
  };
};

exports.fetchMessagesPending = fetchMessagesPending;
var INBOX_FETCH_MESSAGES_ERROR = "inbox/FETCH_MESSAGES/ERROR";
exports.INBOX_FETCH_MESSAGES_ERROR = INBOX_FETCH_MESSAGES_ERROR;

var fetchMessagesError = function fetchMessagesError() {
  return {
    type: INBOX_FETCH_MESSAGES_ERROR
  };
};

exports.fetchMessagesError = fetchMessagesError;
var INBOX_FETCH_MESSAGES_DONE = "inbox/FETCH_MESSAGES/DONE";
exports.INBOX_FETCH_MESSAGES_DONE = INBOX_FETCH_MESSAGES_DONE;

var fetchMessagesDone = function fetchMessagesDone(payload, meta) {
  return {
    type: INBOX_FETCH_MESSAGES_DONE,
    payload: payload,
    meta: meta
  };
};

exports.fetchMessagesDone = fetchMessagesDone;